import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
import HtmlParser from "react-html-parser";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Automated Content<br/> Management",
    description:
      "Effortless content creation, organized storage, and metadata tagging for streamlined management.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Robust CMS <br/> Administration",
    description:
      "Comprehensive governance, detailed analytics, integrated help desk, and instant real-time alerts.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "SEO & <br/>Publishing Tools",
    description:
      "Generate SEO-friendly URLs, implement custom workflows, and offer personalized experiences.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Improved Security & <br/> Compliance",
    description:
      "Utilize multi-factor authentication, enforce role-based permissions, and maintain thorough audit trails.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Integrated Media<br/> Management",
    description:
      "Efficient file management, advanced indexing, comprehensive full-text search, and secure content archiving.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Scalable Multisite <br/> Support",
    description:
      "Support for multisite, multilingual capabilities, and seamless mobile accessibility.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div
      className="workflow digital_marketing_flow speech_business_solutions p-100"
      style={{ background: "#fff" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>Access Superior CMS Features</h2>
            <p>
              Whether your goal is to upscale your current content management
              system or integrate a new one, our expert CMS developers help you
              plan and build customizable products with enterprise-grade
              features. Strengthen your Content Delivery Network with high
              customizability, headless architecture, and workflow automation.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
              <div className="workflow_items" style={{ background: "#f9f9f9" }}>
                <div className="item_name">
                  <span>{item.count}</span>
                  {HtmlParser(item.title)}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-3 mt-md-5"
          >
            <Link
              style={{ background: "#f47a1f", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your CMS Project
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
